export default __webpack_public_path__ + "a043ef3de69363c28cfbbb2b342a0d56.svg";